const AWS = require('aws-sdk');
import { environment } from 'src/environments/environment';

AWS.config.update({
    region: environment.AWS_CONFIG.credentials.region,
    credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.AWS_CONFIG.credentials.identityPool
    })
});

const aws = new AWS.S3()

export async function upload(bucket,key,file,contentType) {
    return await new Promise((resolve,reject)=>{
        const params = {
            Bucket: bucket,
            Key: key,
            Body: file,
            ACL: 'public-read',
            ContentType: contentType
          };
        aws.upload(params,(err,data)=>{
            if(err){
                return reject({error:err});
            }
            return resolve(data)
        })
    })
}

export async function download(bucket: any, key: any) {
    const params = {
      Bucket: bucket,
      Key: `ru-inasistencias/${key}`
    };
    return await aws.getObject(params).promise();
}

export async function getS3File(bucket: any, key: any) {
    const params = {
      Bucket: bucket,
      Key: key
    };
    return await aws.getObject(params).promise();
}

